import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import Attention from "../ReusableComponents/Attention";
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { RiCloseFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";
import TableEmptyState from '../ReusableComponents/TableEmptyState';

const ModalFiscal = (props) => {const { t } = usePreferences();
  const { processo_name, showModal, setShowModal, fiscal, salas_all, OnFinish } = props;
  const [salas_selecionadas, setSalasSelecionadas] = useState({});
  const [selectSala, setSelectSala] = useState('');
  const [salas_total, setSalasTotal] = useState({});

  useEffect(() => {
    if (fiscal != null && fiscal.salas != undefined) {
      let salas_selecionadas_ = {};
      for (let i = 0; i < fiscal.salas.length; i++) {
        salas_selecionadas_[fiscal.salas[i].id] = fiscal.salas[i];
      }
      setSalasSelecionadas(salas_selecionadas_);
    }
  }, [fiscal]);


  useEffect(() => {

    let salas_total_ = {};
    for (let i = 0; i < salas_all.length; i++) {
      salas_total_[salas_all[i].id] = salas_all[i];
    }
    setSalasTotal(salas_total_);

  }, []);


  return (
    fiscal != null && <Modal
      show={showModal == true}
      dialogClassName="modal_width"
      onHide={() => {
        setShowModal(false);
        setSalasSelecionadas({});
      }}>

            <Modal.Header closeButton closeLabel=''><Modal.Title>{`${t("legacy_fiscal")} `}{fiscal.name}<br /></Modal.Title></Modal.Header>
            <Modal.Body>
                <InputGroup>
                    <div className="flex fdcolumn flex1 margin-bottom">
                        <Form.Label>{`${t("rooms")} `}<Attention /></Form.Label>
                        <select className="form-select " onChange={(e) => {
              if (e.target.value != '') {
                let salas_selecionadas_ = { ...salas_selecionadas };
                let salas = { ...salas_total };
                delete salas[e.target.value];
                salas_selecionadas_[e.target.value] = { ...salas_total[e.target.value] };
                setSalasSelecionadas(salas_selecionadas_);
                setSalasTotal(salas);
              }
            }} value={selectSala}>
                            <option value="">{t("placeholder_select_one_or_more_rooms")}</option>
                            {Object.values(salas_total).sort((a, b) => a.created_at - b.created_at).map((value, index) =>
              <option
                key={index}
                value={value["id"]}>{`${t("legacy_sala")} `}
                {value["numero"]}</option>
              )}
                        </select>
                        <a onClick={() => {
              let salas_selecionadas_ = { ...salas_selecionadas };
              Object.values(salas_total).map((value, index) => {
                salas_selecionadas_[value.id] = value;
              });
              setSalasSelecionadas(salas_selecionadas_);
              setSalasTotal({});

            }} style={{ textAlign: 'right', fontSize: 15, marginTop: 10, cursor: 'pointer', textDecoration: 'none' }} className="link-success">{t("action_select_all_rooms")}</a>

                    </div>
                </InputGroup>

                <InputGroup>

                    <div className="flex fdcolumn flex1 margin-bottom">
                        <div className="table-modern-card">
                            <div className="table-modern-scroll">
                                <table id="tech-companies-1" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t("legacy_sala")}</th>

                                            <th data-priority="3">{t("label_actions")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.values(salas_selecionadas).sort((a, b) => a.created_at - b.created_at).map((item, id) =>
                    <tr key={id}>
                                                <td>{`${t("legacy_sala")} `}{item.numero}</td>

                                                <td>
                                                    <div className="actions-group">
                                                    <span
                          onClick={(e) => {
                            let salas = { ...salas_total };
                            salas[item.id] = { ...salas_selecionadas[item.id] };

                            let salas_selecionadas_ = { ...salas_selecionadas };
                            delete salas_selecionadas_[item.id];

                            setSalasSelecionadas(salas_selecionadas_);
                            setSalasTotal(salas);
                          }}
                          className="inline-flex align-center jcc bg-danger icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("action_delete_room")}>

                                                        <MdDelete size={17} color="white" />
                                                    </span>

                                                    </div>
                                                    </td>

                                            </tr>
                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {Object.values(salas_selecionadas).length == 0 && <div className="row">
                            <div className="col-12">
                                <TableEmptyState title={t("ui_nenhuma_sala_selecionada_bf0df991")} icon="📋" />

                            </div>
                        </div>}
                    </div>

                </InputGroup>


                {<div className="w100 inline-flex jcsb margin-top-1">
                    {/* <Link to={`/accounts/list`}>
            <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
            </Link> */}
                    <DefaultButton
            bg="secondary"
            text={t("action_close")}
            icon={<RiCloseFill />}
            onClick={() => {
              setShowModal(false);
              setSalasSelecionadas({});
            }} />

                    {/* <Button variant="success" type="submit" disabled={this.loading}>
            {this.state.loading ? <Spinner /> : ""}
            Registrar usuário
            </Button> */}
                    <DefaultButton
            type="button"
            disabled={Object.values(salas_selecionadas).length == 0}

            onClick={() => {
              OnFinish(Object.values({ ...salas_selecionadas }).sort((a, b) => a.created_at - b.created_at), fiscal);
              setShowModal(false);

              setSalasSelecionadas({});

            }}
            bg={Object.values(salas_selecionadas).length > 0 ? "confirm" : "secondary"}
            text={t("action_save")} />

                </div>}

            </Modal.Body>
        </Modal>);


};

export default ModalFiscal;
